import normalize from "json-api-normalizer";
import { get } from "lodash";
import { push } from "connected-react-router";

import { ASYNC_START, ASYNC_END, SET_FEATURES, FEATURE_SAVED, FEATURE_SAVE_FAILED, SET_FEATURES_FAILED } from "./types";
import FeaturesService from "../services/features.service";
import NotificationService from "../services/notification.service";
import EncodingFiltersService from "../services/encoding-filters.service";

export const initFeatures = () => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  dispatch({ type: ASYNC_START });

  try {
    const featureResult = await FeaturesService.getFeatures(tenantSlug);
    const normalizedFeatures = featureResult.data.data.length ? normalize(featureResult.data) : { productMetadataTypes: {} };

    dispatch(setFeatures(normalizedFeatures));
    dispatch({ type: ASYNC_END });
  } catch (e) {
    dispatch(setFeaturesFailed());
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Failed featching the features! ${NotificationService.handleMessage(e)}`);
  }
};

export const filterFeatures = filter => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  dispatch({ type: ASYNC_START });

  try {
    const featuresResult = await FeaturesService.getFilteredFeatures(tenantSlug, EncodingFiltersService.encode(filter));
    const normalizedFeatures = featuresResult.data.data.length
      ? normalize(featuresResult.data)
      : { productMetadataTypes: {} };
    dispatch(setFeatures(normalizedFeatures));
    dispatch({ type: ASYNC_END });
  } catch (e) {
    dispatch(setFeaturesFailed());
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Failed filtering the features! ${NotificationService.handleMessage(e)}`);
  }
};

export const fetchUnfilteredFeatures = () =>
  filterFeatures({
    filter: { archived: "true,false" }
  });

export const fetchFeature = slug => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  try {
    const featureResult = await FeaturesService.getFeature(slug, tenantSlug);
    const normalizedFeatures = normalize(featureResult.data);
    dispatch(setFeatures(normalizedFeatures));
  } catch (e) {
    dispatch(setFeaturesFailed());
    NotificationService.addError(`Failed featching the feature! ${NotificationService.handleMessage(e)}`);
  }
};

export const createFeature = featureData => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  dispatch({ type: ASYNC_START });
  try {
    await FeaturesService.createFeature(featureData, tenantSlug);
    dispatch(featureSaved());
    dispatch({ type: ASYNC_END });
    dispatch(push("/features"));
    NotificationService.addSuccess("Feature successfully created!");
  } catch (e) {
    dispatch(featureSaveFailed());
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Failed creating the feature! ${NotificationService.handleMessage(e)}`);
  }
};

export const toggleArchivedFeature = (slug, featureData) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  dispatch({ type: ASYNC_START });

  try {
    await FeaturesService.updateFeature(slug, featureData, tenantSlug);
    dispatch(featureSaved());
    dispatch({ type: ASYNC_END });
    // this is currently needed because the UI doesn't retain the data
    dispatch(
      filterFeatures({
        filter: {
          archived: !featureData.archived
        }
      })
    );
    NotificationService.addSuccess(`Feature successfully ${featureData.archived ? "archived!" : "activated!"}`);
  } catch (e) {
    dispatch(featureSaveFailed());
    dispatch({ type: ASYNC_END });
    NotificationService.addError(
      `Failed ${featureData.archived ? "archiving!" : "activating!"} the bundle! ${NotificationService.handleMessage(e)}`
    );
  }
};

export const editFeature = (slug, featureData) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");
  dispatch({ type: ASYNC_START });
  try {
    await FeaturesService.updateFeature(slug, featureData, tenantSlug);
    dispatch(featureSaved());
    dispatch({ type: ASYNC_END });
    dispatch(push("/features"));

    NotificationService.addSuccess("Feature successfully updated!");
  } catch (e) {
    dispatch(featureSaveFailed());
    dispatch({ type: ASYNC_END });

    NotificationService.addError(`Failed updating the feature! ${NotificationService.handleMessage(e)}`);
  }
};

export const setFeatures = features => {
  return {
    type: SET_FEATURES,
    features: features
  };
};

export const setFeaturesFailed = () => {
  return {
    type: SET_FEATURES_FAILED
  };
};

export const featureSaved = () => {
  return {
    type: FEATURE_SAVED
  };
};

export const featureSaveFailed = () => {
  return {
    type: FEATURE_SAVE_FAILED
  };
};
